import translate from '../../core/services/translate';

export const getSpeedInformation = (speed: number, unitOfMeasure: string) =>
  speed < 0 ? translate('common.notAvailable') : `${speed || 0} ${unitOfMeasure}`;
